__turbopack_context__.v({
  "bar": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__bar",
  "current": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__current",
  "inner": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__inner",
  "inverted": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__inverted",
  "item": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__item",
  "link": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__link",
  "list": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__list",
  "separator": "PdpBreadcrumbsBar-module-scss-module__IYFUVG__separator",
});
